import React from 'react'
import { TextField } from '@atd/rui-base.mui.text-field'

export default function ValidatedTextField({ errorText, ...props }) {
    return (
        <TextField
            variant="standard"
            margin="normal"
            error={Boolean(errorText)}
            helperText={errorText || ''}
            {...props}
        />
    )
}
